import { graphql } from '@gql/gql';

export const getCatalogConstructionTypesGql = graphql(`
    query catalogConstructionTypes(
        $skip: Int
        $take: Int
        $order: [ConstructionTypeDataSortInput!]
        $where: ConstructionTypeDataFilterInput
    ) {
        catalogConstructionTypes(skip: $skip, take: $take, order: $order, where: $where) {
            items {
                catalogId
                code
                fullName
                iconCode
                id
                name
                shortName
                uniqueId
                updatedAt
                contractFileName
                createdAt
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const getCatalogConstructionTypeItemsGql = graphql(`
    query catalogConstructionTypeItems(
        $skip: Int
        $take: Int
        $order: [ConstructionTypeDataSortInput!]
        $where: ConstructionTypeDataFilterInput
        $catalogUniqueId: String!
    ) {
        catalogConstructionTypeItems(
            catalogUniqueId: $catalogUniqueId
            skip: $skip
            take: $take
            order: $order
            where: $where
        ) {
            items {
                contractFileName
                catalogId
                code
                fullName
                iconCode
                id
                name
                shortName
                uniqueId
                updatedAt
                createdAt
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const catalogIsUniqueConstructionTypeFieldsGql = graphql(`
    query catalogIsUniqueConstructionTypeFields(
        $catalogConstructionTypeId: Int
        $name: String!
        $fullName: String!
        $shortName: String!
        $contractFileName: String!
    ) {
        catalogIsUniqueConstructionTypeFields(
            catalogConstructionTypeId: $catalogConstructionTypeId
            name: $name
            fullName: $fullName
            shortName: $shortName
            contractFileName: $contractFileName
        ) {
            result
            message
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            validation {
                message
                metadata
                property
                source
            }
        }
    }
`);

export const catalogConstructionTypesUpdatedDate = graphql(`
    query catalogConstructionTypesUpdatedDate($catalogId: Long!) {
        catalogConstructionTypesUpdatedDate(catalogId: $catalogId) {
            result
            message
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            validation {
                message
                metadata
                property
                source
            }
            data {
                catalogId
                updatedAt
            }
        }
    }
`);

export const catalogCreateConstructionTypeMutation = graphql(`
    mutation catalogCreateConstructionType($input: CatalogConstructionTypeCreateInput!) {
        catalogCreateConstructionType(input: $input) {
            result
            message
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            validation {
                message
                metadata
                property
                source
            }
            data {
                catalogId
                code
                fullName
                iconCode
                id
                name
                shortName
                uniqueId
                updatedAt
                contractFileName
                createdAt
            }
        }
    }
`);

export const catalogUpdateConstructionTypeMutation = graphql(`
    mutation catalogUpdateConstructionType($input: CatalogConstructionTypeUpdateInput!) {
        catalogUpdateConstructionType(input: $input) {
            result
            message
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            validation {
                message
                metadata
                property
                source
            }
            data {
                catalogId
                code
                fullName
                iconCode
                id
                name
                shortName
                uniqueId
                updatedAt
                contractFileName
                createdAt
            }
        }
    }
`);

export const catalogRemoveConstructionTypeMutation = graphql(`
    mutation catalogRemoveConstructionType($catalogConstructionTypeId: Int!) {
        catalogRemoveConstructionType(catalogConstructionTypeId: $catalogConstructionTypeId) {
            result
            message
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            validation {
                message
                metadata
                property
                source
            }
            id
        }
    }
`);

export const catalogIsUniqueConstructionTypeCodeGql = graphql(`
    query catalogIsUniqueConstructionTypeCode($catalogConstructionTypeId: Int, $code: String!) {
        catalogIsUniqueConstructionTypeCode(catalogConstructionTypeId: $catalogConstructionTypeId, code: $code) {
            result
            message
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            validation {
                message
                metadata
                property
                source
            }
        }
    }
`);

export const catalogConstructionTypeIsUsedInProjectsGql = graphql(`
    query catalogConstructionTypeIsUsedInProjects($code: String!) {
        catalogConstructionTypeIsUsedInProjects(code: $code) {
            result
            message
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            validation {
                message
                metadata
                property
                source
            }
        }
    }
`);
